import { helper } from '@ember/component/helper';

import { get, set } from 'rise-ui/utils/object.js';

export default helper(function metaToggleAllHelper([ metaArr, key ]) {
  return () => {
    const value = !metaArr.every(m => get(m, key));
    for (let i = 0, len = metaArr?.length || 0; i < len; ++i) {
      set(metaArr[i], key, value);
    }
    metaArr.setObjects(metaArr);
  };
});
